module.exports = __webpack_public_path__ + "static/media/img33.4e041371.jpg";